import src from "./vogue.svg";
export default { src: src, aspect: 3.7037, width: 100, height: 27 };